/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTaxFormPrefill} from '../api'

 export const useQueryGetTaxFormPrefill = createReactQueryHook('getTaxFormPrefill', getTaxFormPrefill)
